export const environment = {
  production: true,
  API_URL: '/'
};
